<div class="container-fluid full-height">

    <div class="d-flex justify-content-end my-4">
        <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
    </div>

<ng-container *ngFor="let item of consumptionPeriodDetail | search:searchText; let i=index">
    <div class="d-flex justify-content-between timeline-date" *ngIf="timeLine[i] ? timeLine[i].date != false : false">
        <div class="col-auto p-0 date_title"  *ngIf="timeLine[i].date != false">
             {{timeLine[i].isToday ? (translationKeys.Dashboard.Today | translate)+', ' : '' }} {{timeLine[i].date}}
          
        </div>
    </div>

    <div class="col-12 p-0 card-strip card-strip-protocol d-flex">
        <div class="card-task mb-0">
            <div class="col card-task-content d-flex p-3"  (click)="onClick(item)">
                <div class="col-5">
                    <div> 
                        <h3 class="section-title">{{ item.departmentName | translate | labelSanitizer}} / {{item.wardName | translate | labelSanitizer}} / {{item.year}} </h3>
                    </div>
                </div>

                <div class="col">
                    <div> 
                        <h3 class="section-title">{{ item.consumptionValue}} {{unitMeasure(item.year) | translate}} {{ amountMeasure(item.year) | translate}} </h3>
                    </div>
                </div>

                <div class="col">
                    <div> 
                        <h3 class="section-title">{{ item.patientDays }} {{'CONSUMPTION.PATIENT_DAYS' | translate }}</h3>
                    </div>
                </div>
                
                <div class="col" *ngIf="haiEnabled">
                    <div>
                        <h3 class="section-title">{{ item.haiOccurrences }} {{'CONSUMPTION.HAI_OCCURRENCES' | translate }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container> 

</div>